// @flow
import * as React from 'react';
import styled from 'styled-components';
import { translate } from 'react-i18next';
import { Card, Container, Spacer } from 'statsradio/themes/v3/Stylesheet';

import DashboardGenderCard from './DashboardGenderCard';
import AgeGroupPane from './AgeGroupPane';
import GeolocalisationCard from './GeolocalisationCard';
import type { DashboardMetrics } from '../../../domain/DashboardData';

const DemoTitle = styled.h2`
  margin: 24px;
`;

const DemographyCard = styled(Card)`
  height: 450px;
  flex-direction: column;
  
  box-sizing: border-box;
  padding: ${props => props.theme.V3.metrics.margin.large}px;
`;

const DemographyContainer = styled.div`
  display: flex;

  width: 100%;
  height: 100%;
  
  margin-top: ${props => props.theme.V3.metrics.margin.normal}px;
`;

const DemographySectionContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  
  height: 100%;
  box-sizing: border-box;
`;

const DemographySection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  
  height: 100%;
  width: ${props => props.width};
  
  h3 {
    padding: 0 ${props => props.theme.V3.metrics.margin.normal}px;
  }
  
  ${DemographySectionContent} {
    padding: ${props => props.theme.V3.metrics.margin.normal}px;
  }
`;

interface Props {
  data: DashboardMetrics,

  t: any,
}

function DemographyComponent({ data, t }: Props) {
  return (
    <Container>
      <DemographyCard>
        <DemoTitle>{t('demography')}</DemoTitle>
        <DemographyContainer>
          <DemographySection width="36%">
            <h3>{t('geolocalisation')}</h3>
            <DemographySectionContent>
              <GeolocalisationCard geolocalisation={data.reachByGeolocation} />
            </DemographySectionContent>
          </DemographySection>
          <Spacer />
          <DemographySection width="36%">
            <h3>{t('ages')}</h3>
            <DemographySectionContent>
              <AgeGroupPane ageRangeReaches={data.reachByAgeRange} />
            </DemographySectionContent>
          </DemographySection>
          <Spacer />
          <DemographySection width="28%">
            <h3>{t('gender')}</h3>
            <DemographySectionContent>
              <DashboardGenderCard metrics={data.reachByGender} />
            </DemographySectionContent>
          </DemographySection>
        </DemographyContainer>
      </DemographyCard>
    </Container>
  );
}

export default translate('dashboard', 'metrics')(DemographyComponent);



// WEBPACK FOOTER //
// ./src/statsradio/modules/dashboard/v2/components/demography/DemographyComponent.js